<template>

	<div class="default-theme-edit-panel">

		<div v-for="(block,blockIndex) in blocks">

			<div class="panel panel-default">
				<div class="panel-heading clearfix"
				     :class="{'error':block.errorMessage}"
				     @click.stop.prevent="block.toggleEdit">
					<div class="pull-left">
					<span>
						{{block.name?block.name:"请填写索引栏名称"}}
					</span>
					</div>
					<div class="pull-right">
						<a class="btn-action" title="完成" v-show="block.editMode" @click.stop.prevent="block.toggleEdit">
							<i class="fa fa-check text-warning f18"></i>
						</a>

						<a class="btn-action" title="编辑" v-show="!block.editMode"
						   @click.stop.prevent="block.toggleEdit">
							<i class="fa fa-pencil text-warning f18"></i>
						</a>

						<a class="btn-action" title="添加条目" v-show="!block.editMode"
						   @click.stop.prevent="block.addItem">
							<i class="fa fa-plus text-success f18"></i>
						</a>

						<a class="btn-action" title="上移" v-show="!block.editMode" @click.stop.prevent="upBlock(blockIndex)">
							<i class="fa fa-arrow-up f18"></i>
						</a>

						<a class="btn-action" title="下移" v-show="!block.editMode" @click.stop.prevent="downBlock(blockIndex)">
							<i class="fa fa-arrow-down f18"></i>
						</a>

						<a class="btn-action" title="删除" @click.stop.prevent="delBlock(blockIndex)">
							<i class="fa fa-trash text-danger f18"></i>
						</a>
					</div>

				</div>

				<NbExpanding>
					<div class="panel-body" v-show="block.editMode">

						<div class="form-group">
							<div class="col-xs-12">
								<div class="row">
									<label class="col-md-2 control-label mt5">索引栏名称</label>
									<div class="col-md-10">
										<input type="text" class="form-control" v-model="block.name"/>
									</div>
								</div>


								<div class="row">
									<div class="alert alert-danger mv10" v-show="block.errorMessage">
										{{block.errorMessage}}
									</div>
								</div>
							</div>

						</div>


					</div>
				</NbExpanding>


			</div>

			<div class="ml25" v-for="(item,itemIndex) in block.items">

				<div class="panel panel-default">
					<div class="panel-heading clearfix"
					     :class="{'error':item.errorMessage}"
					     @click.stop.prevent="item.toggleEdit">
						<div class="pull-left">
							<span class="color-555">
								{{item.name?item.name:"请填写条目名称"}}
							</span>

							<span class="ml10 label-url" v-if="item.type === 'URL'">
								<i class="fa fa-link"></i>
								{{item.url}}
							</span>

							<span class="ml10 label-article" v-if="item.type === 'ARTICLE'">
								<i class="fa fa-file-o"></i>
								{{item.article.title}}
							</span>

						</div>
						<div class="pull-right">
							<a class="btn-action" title="完成" v-show="item.editMode" @click.stop.prevent="item.toggleEdit">
								<i class="fa fa-check text-warning f18"></i>
							</a>

							<a class="btn-action" title="编辑" v-show="!item.editMode"
							   @click.stop.prevent="item.toggleEdit">
								<i class="fa fa-pencil text-warning f18"></i>
							</a>

							<a class="btn-action" title="上移" v-show="!item.editMode" @click.stop.prevent="upItem(block,itemIndex)">
								<i class="fa fa-arrow-up f18"></i>
							</a>

							<a class="btn-action" title="下移" v-show="!item.editMode" @click.stop.prevent="downItem(block,itemIndex)">
								<i class="fa fa-arrow-down f18"></i>
							</a>

							<a class="btn-action" title="删除" @click.stop.prevent="delItem(block,itemIndex)">
								<i class="fa fa-trash text-danger f18"></i>
							</a>
						</div>

					</div>

					<NbExpanding>
						<div class="panel-body" v-show="item.editMode">

							<div class="form-group">
								<div class="col-xs-12">
									<div class="row">
										<label class="col-md-2 control-label mt5">条目名称</label>
										<div class="col-md-10">
											<input type="text" class="form-control" v-model="item.name"/>
										</div>
									</div>

									<div class="row mt10">
										<label class="col-md-2 control-label mt5">类型</label>
										<div class="col-md-10">
											<select class="form-control"
											        name="type" v-model="item.type">
												<option v-for="type in item.TypeList" :value="type.value">{{type.name}}</option>
											</select>
										</div>
									</div>

									<div class="row mt10" v-if="item.type === 'ARTICLE'">
										<label class="col-md-2 control-label mt5">关联文章</label>
										<div class="col-md-10">
											<ArticlePagerSelection :activeArticle="item.article"/>
										</div>
									</div>

									<div class="row mt10" v-if="item.type === 'URL'">
										<label class="col-md-2 control-label mt5">自定义链接</label>
										<div class="col-md-10">
											<input type="text" class="form-control" v-model="item.url"/>
										</div>
									</div>


									<div class="row">
										<div class="alert alert-danger mv10" v-show="item.errorMessage">
											{{item.errorMessage}}
										</div>
									</div>


								</div>

							</div>


						</div>
					</NbExpanding>


				</div>
			</div>

		</div>


		<div class="level add" @click.stop.prevent="addBlock">
			<i class="fa fa-plus"></i>
			添加索引栏
		</div>

	</div>


</template>

<script>
	import {MessageBox, Notification} from 'element-ui';
	import Block from '../../../../common/model/lover/theme/Block'
	import Item from '../../../../common/model/lover/theme/Item'
	import NbExpanding from '../../../../common/widget/NbExpanding.vue'
	import ArticlePagerSelection from '../../../../backyard/view/article/Selection.vue'
	export default {
		//这个值代表的remark的变化
		model: {
			prop: 'remark',
			event: 'remark'
		},
		data () {
			return {
				innerRemark: null,
				user: this.$store.state.user,
				blocks: []
			}
		},
		props: {
			remark: {
				type: String,
				required: false,
				"default": false
			}
		},
		computed: {},
		components: {
			NbExpanding,
			ArticlePagerSelection
		},
		watch: {
			"remark"(newVal, oldVal){
				if (newVal === this.innerRemark) {
					//Event from inner.
				} else {
					//Event from outer

					//渲染数据
					this.renderData();


				}
			}
		},
		methods: {
			renderData(){
				this.innerRemark = this.remark;
				try {
					let arr = JSON.parse(this.innerRemark);
					if (arr instanceof Array) {

						//首先清空现有的。
						this.blocks.splice(0, this.blocks.length);
						for (let i = 0; i < arr.length; i++) {
							let obj = arr[i];
							let block = new Block();
							block.render(obj);
							this.blocks.push(block);
						}

					}
				} catch (e) {
					console.error("传入的remark数据出错！");
				}
			},
			validate(){

				//检查每个block和每个item的正确性。
				for (let i = 0; i < this.blocks.length; i++) {
					let block = this.blocks[i];
					if (!block.validate()) {
						return false;
					}

					for (let j = 0; j < block.items.length; j++) {
						let item = block.items[j];
						if (!item.validate()) {
							return false;
						}
					}
				}

				let remarkInfo = [];
				for (let i = 0; i < this.blocks.length; i++) {
					let block = this.blocks[i];
					remarkInfo.push(block.getForm());
				}

				this.innerRemark = JSON.stringify(remarkInfo);
				this.$emit('remark', this.innerRemark);

				return true;

			},
			refresh(){
			},
			addBlock(){
				let block = new Block();
				block.editMode = true;
				this.blocks.push(block);
			},
			upBlock(index){
				let block = this.blocks[index];
				if (index !== 0) {
					this.blocks.splice(index, 1);
					this.blocks.splice(index - 1, 0, block);
				}
			},
			downBlock(index){
				let block = this.blocks[index];
				if (index !== this.blocks.length - 1) {
					this.blocks.splice(index, 1);
					this.blocks.splice(index + 1, 0, block);
				}
			},
			delBlock(index){
				let that = this;
				MessageBox.confirm('此操作该索引栏及其子条目，确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						that.blocks.splice(index, 1);
					}
				);
			},
			upItem(block, index){
				let item = block.items[index];
				if (index !== 0) {
					block.items.splice(index, 1);
					block.items.splice(index - 1, 0, item);
				}
			},
			downItem(block, index){
				let item = block.items[index];
				if (index !== this.items.length - 1) {
					block.items.splice(index, 1);
					block.items.splice(index + 1, 0, item);
				}
			},
			delItem(block, index){
				let that = this;
				MessageBox.confirm('此操作该条目，确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						block.items.splice(index, 1);
					}
				);
			}

		},
		created(){

		},
		mounted(){
			//渲染数据
			this.renderData();
		}
	}

</script>


<style lang="less" rel="stylesheet/less">

	.default-theme-edit-panel {

		@color-bg: #F8FAFF;
		@color-bg-highlight: #F4F6F7;
		@color-border: #DAE2EA;
		@color-border-highlight: #DCE2E8;
		@color-attribute: #d9534f;
		@color-attribute-highlight: #d91903;
		@color-field: #3F6AB2;
		@color-field-highlight: #0645b2;
		@color-block: #0cb20c;
		@color-block-highlight: #0ab224;

		@color-collection: #b28813;
		@color-collection-highlight: #b26905;
		@color-add-btn: #999;
		@color-add-btn-highlight: #555;

		.label-attribute {
			font-weight: bold;
			color: @color-attribute;
		}
		.label-article {
			font-weight: bold;
			color: @color-collection-highlight;
		}
		.label-url {
			font-weight: bold;
			color: @color-block-highlight;
		}

		.label-field {
			font-weight: bold;
			color: @color-field;
		}

		option:disabled {
			color: red;
		}

		.level-block {
			margin: 5px 0 5px 25px;
		}
		> .level-block {
			margin-left: 0;
		}

		.panel {
			margin-bottom: 5px;
		}
		.panel-body {
			border-top: 1px solid #ddd;
		}
		.level, .panel-heading {

			border-color: transparent;

			&.error {
				border: 1px dashed red;
			}

			cursor: pointer;
			background: @color-bg;
			color: @color-field;

			text-decoration: none;
			font-weight: bold;
			-webkit-box-sizing: border-box;
			-moz-box-sizing: border-box;
			box-sizing: border-box;

			//添加属性按钮
			&.add {

				min-height: 38px;
				margin: 5px 0;
				padding: 8px 12px;

				text-align: center;
				border: 1px dashed @color-add-btn;
				color: @color-add-btn;
			}

			&:hover {
				color: @color-field-highlight;

				background: @color-bg-highlight;
				&.add {
					border: 1px dashed @color-add-btn-highlight;
					color: @color-add-btn-highlight;
				}
			}
		}

	}
</style>




// WEBPACK FOOTER //
// DefaultThemeEditPanel.vue?7fde5800